import { CircularProgress } from '@mui/material';
import { Dialog } from '@mui/material';

const AuthenticatingPopup = () => {
  return (
    <Dialog open={true} fullScreen={true}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F2F5F7',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          alt={''}
          style={{ height: 50, marginBottom: 20 }}
          src={'/favicon-1.png'}
        />
        <CircularProgress color="primary" style={{ width: 20, height: 20 }} />
      </div>
    </Dialog>
  );
};

export default AuthenticatingPopup;
